<template>
  <div class="admin-projects">
    <div class="page-header">
      <h2 class="page-title">项目管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="createProject">新建项目</el-button>
    </div>

    <el-table :data="projects" v-loading="loading" stripe fit style="width: 100%">
      <el-table-column prop="name" label="名称" min-width="200" show-overflow-tooltip />
      <el-table-column prop="lang" label="语言" min-width="80" />
      <el-table-column prop="stars" label="Stars" width="70" />
      <el-table-column prop="forks" label="Forks" width="70" />
      <el-table-column label="私有" width="70">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_private ? 'danger' : 'success'" size="mini">
            {{ scope.row.is_private ? 'Private' : 'Public' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="70">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_active ? 'success' : 'info'" size="mini">
            {{ scope.row.is_active ? '显示' : '隐藏' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updated_date" label="更新日期" width="110" />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="editProject(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteProject(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { adminApi } from '../../utils/api'

export default {
  name: 'AdminProjects',
  data() {
    return {
      projects: [],
      loading: false
    }
  },
  created() {
    this.loadProjects()
  },
  methods: {
    async loadProjects() {
      this.loading = true
      try {
        const res = await adminApi.getProjects()
        this.projects = res.projects || []
      } catch (e) {
        console.error(e)
        this.$message.error('加载失败')
      }
      this.loading = false
    },
    createProject() {
      this.$router.push('/admin/projects/create')
    },
    editProject(row) {
      this.$router.push(`/admin/projects/edit/${row.id}`)
    },
    async deleteProject(row) {
      try {
        await this.$confirm('确定删除该项目吗？', '提示', { type: 'warning' })
        await adminApi.deleteProject(row.id)
        this.$message.success('删除成功')
        this.loadProjects()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--blog-text);
  margin: 0;
}
</style>
